export default __webpack_public_path__ + "static/media/empty_yellow_star.ec7fee10.svg";